module.exports = __webpack_public_path__ + "static/media/video3-beenleigh.9755b236.mp4";